(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_130d743_p68PYw"] && !Shopify.designMode) return;
  try {
    (function () {
    function setViewportWidth(ticker) {
      var vw = document.documentElement.clientWidth;
      if (vw) ticker.style.setProperty('--ai-ticker-vw', vw + 'px');
    }

    function layout(ticker) {
      var track = ticker.querySelector('[data-ticker-track]');
      if (!track) return;

      var copies = track.querySelectorAll('[data-ticker-copy]');
      if (!copies.length) return;

      var master = copies[0];
      var copyWidth = master.getBoundingClientRect().width;
      if (!copyWidth) return;

      setViewportWidth(ticker);

      var containerWidth = ticker.getBoundingClientRect().width || document.documentElement.clientWidth;
      var needed = Math.max(2, Math.ceil((containerWidth * 2) / copyWidth) + 1);
      var current = copies.length;

      if (needed > current) {
        var fragment = document.createDocumentFragment();
        for (var i = current; i < needed; i++) {
          fragment.appendChild(master.cloneNode(true));
        }
        track.appendChild(fragment);
      } else if (needed < current) {
        for (var j = current - 1; j >= needed; j--) {
          track.removeChild(copies[j]);
        }
      }

      var speed = parseFloat(ticker.getAttribute('data-ticker-speed')) || 60;
      track.style.setProperty('--ai-ticker-shift', '-' + copyWidth.toFixed(3) + 'px');
      track.style.setProperty('--ai-ticker-duration', (copyWidth / speed).toFixed(3) + 's');
    }

    function layoutAll(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var tickers = scope.querySelectorAll('[data-ticker]');
      Array.prototype.forEach.call(tickers, layout);
    }

    function whenIconsReady(callback) {
      var images = document.querySelectorAll('[data-ticker] img');
      var pending = 0;

      Array.prototype.forEach.call(images, function (img) {
        if (img.complete) return;
        pending++;
        var done = function () {
          img.removeEventListener('load', done);
          img.removeEventListener('error', done);
          if (--pending === 0) callback();
        };
        img.addEventListener('load', done);
        img.addEventListener('error', done);
      });

      if (pending === 0) callback();
    }

    function start() {
      layoutAll(document);
      whenIconsReady(function () { layoutAll(document); });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { layoutAll(document); });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    var lastWidth = document.documentElement.clientWidth;
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var width = document.documentElement.clientWidth;
        if (width === lastWidth) return;
        lastWidth = width;
        layoutAll(document);
      }, 200);
    });

    document.addEventListener('shopify:section:load', function (event) {
      layoutAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_1ae9527"] && !Shopify.designMode) return;
  try {
    (function () {
    function setWidth(banner) {
      var vw = document.documentElement.clientWidth;
      if (vw) banner.style.setProperty('--ai-hero-vw', vw + 'px');
    }
    function setAll(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var banners = scope.querySelectorAll('[data-hero-banner]');
      Array.prototype.forEach.call(banners, setWidth);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setAll(document); });
    } else {
      setAll(document);
    }
    var lastWidth = document.documentElement.clientWidth;
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var width = document.documentElement.clientWidth;
        if (width === lastWidth) return;
        lastWidth = width;
        setAll(document);
      }, 150);
    });
    document.addEventListener('shopify:section:load', function (event) {
      setAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_b00ac08"] && !Shopify.designMode) return;
  try {
    (function () {
    function setViewportWidth(ticker) {
      var vw = document.documentElement.clientWidth;
      if (vw) ticker.style.setProperty('--ai-ticker-vw', vw + 'px');
    }

    function layout(ticker) {
      var track = ticker.querySelector('[data-ticker-track]');
      if (!track) return;

      var copies = track.querySelectorAll('[data-ticker-copy]');
      if (!copies.length) return;

      var master = copies[0];
      var copyWidth = master.getBoundingClientRect().width;
      if (!copyWidth) return;

      setViewportWidth(ticker);

      var containerWidth = ticker.getBoundingClientRect().width || document.documentElement.clientWidth;
      var needed = Math.max(2, Math.ceil((containerWidth * 2) / copyWidth) + 1);
      var current = copies.length;

      if (needed > current) {
        var fragment = document.createDocumentFragment();
        for (var i = current; i < needed; i++) {
          fragment.appendChild(master.cloneNode(true));
        }
        track.appendChild(fragment);
      } else if (needed < current) {
        for (var j = current - 1; j >= needed; j--) {
          track.removeChild(copies[j]);
        }
      }

      var speed = parseFloat(ticker.getAttribute('data-ticker-speed')) || 60;
      track.style.setProperty('--ai-ticker-shift', '-' + copyWidth.toFixed(3) + 'px');
      track.style.setProperty('--ai-ticker-duration', (copyWidth / speed).toFixed(3) + 's');
    }

    function layoutAll(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var tickers = scope.querySelectorAll('[data-ticker]');
      Array.prototype.forEach.call(tickers, layout);
    }

    function whenIconsReady(callback) {
      var images = document.querySelectorAll('[data-ticker] img');
      var pending = 0;

      Array.prototype.forEach.call(images, function (img) {
        if (img.complete) return;
        pending++;
        var done = function () {
          img.removeEventListener('load', done);
          img.removeEventListener('error', done);
          if (--pending === 0) callback();
        };
        img.addEventListener('load', done);
        img.addEventListener('error', done);
      });

      if (pending === 0) callback();
    }

    function start() {
      layoutAll(document);
      whenIconsReady(function () { layoutAll(document); });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { layoutAll(document); });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    var lastWidth = document.documentElement.clientWidth;
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var width = document.documentElement.clientWidth;
        if (width === lastWidth) return;
        lastWidth = width;
        layoutAll(document);
      }, 200);
    });

    document.addEventListener('shopify:section:load', function (event) {
      layoutAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
